var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassTable",
    { staticClass: "table-loading" },
    [
      _c(
        "CompassTableHead",
        { staticClass: "table-loading__head" },
        _vm._l(4, function(column) {
          return _c("CompassTableHeadCell", { key: column })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "CompassTableBody",
        _vm._l(5, function(row) {
          return _c(
            "CompassTableRow",
            { key: row },
            [
              _c(
                "CompassTableBodyCell",
                { attrs: { maxWidth: "48px", minWidth: "48px" } },
                [_c("CompassSkeleton", { attrs: { variant: "square" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "CompassTableBodyCell",
                { attrs: { maxWidth: "190px", minWidth: "190px" } },
                [_c("CompassSkeleton")],
                1
              ),
              _vm._v(" "),
              _c(
                "CompassTableBodyCell",
                { attrs: { maxWidth: "260px", minWidth: "260px" } },
                [_c("CompassSkeleton")],
                1
              ),
              _vm._v(" "),
              _c("CompassTableBodyCell", [_c("CompassSkeleton")], 1)
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }